var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSource(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 21.6667C17.3825 22.6236 18.2957 23.4153 19.3443 23.9883C20.393 24.5612 21.5526 24.9019 22.7445 24.9872C23.9364 25.0726 25.1327 24.9006 26.2523 24.483C27.3719 24.0654 28.3886 23.4118 29.2334 22.5667L34.2334 17.5667C35.7514 15.995 36.5914 13.89 36.5724 11.705C36.5534 9.52004 35.677 7.42994 34.1319 5.88487C32.5868 4.3398 30.4967 3.46339 28.3118 3.44441C26.1268 3.42542 24.0218 4.26537 22.4501 5.78336L19.5834 8.63336",
    stroke: "#374151",
    strokeWidth: 3.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3334 18.3333C22.6177 17.3764 21.7045 16.5847 20.6558 16.0117C19.6072 15.4388 18.4476 15.0981 17.2557 15.0127C16.0638 14.9274 14.8674 15.0994 13.7478 15.517C12.6282 15.9346 11.6116 16.5882 10.7668 17.4333L5.76676 22.4333C4.24877 24.005 3.40882 26.11 3.42781 28.295C3.44679 30.48 4.3232 32.5701 5.86827 34.1151C7.41334 35.6602 9.50344 36.5366 11.6884 36.5556C13.8734 36.5746 15.9784 35.7346 17.5501 34.2166L20.4001 31.3666",
    stroke: "#374151",
    strokeWidth: 3.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSource);
export default __webpack_public_path__ + "static/media/source.3d3dbc1582dfbaad48c73b885e81c67d.svg";
export { ForwardRef as ReactComponent };